import { LockResponseDto } from "@api-types/locks/LockResponseDto";
import { action, observable } from "mobx";
import { localizationService } from "@state";

import { getCurrentCulture } from "@utils";
import { LazyImportWithLoadFailHandle as lazy } from "@lib/lazy-import-with-guard/LazyImportWithGuard";
import type { RootStore } from "@state/stores/types";
import BasePopupStore from "@state/stores/popups/BasePopupStore";

const loadFailPath = `/${getCurrentCulture()}/app-update`;

// prettier-ignore
const TwAgencyUserLocksApiService = lazy(loadFailPath, ()=>import("@api-services/locks/TwAgencyUserLocksApiService"));

export default class User24hLockStore extends BasePopupStore {
	@observable responseData: LockResponseDto | null;
	constructor(rootStore: RootStore) {
		super(rootStore);
	}
	@action.bound
	async lockUser() {
		try {
			this.responseData = await (
				await TwAgencyUserLocksApiService
			).default.oasisTemporaryLock();
			await this.rootStore.userAuthStore.logoutUser();
			this.activatePopup();
		} catch (error) {
			console.error(error);
			this.rootStore.notificationStore.error(
				localizationService.t(
					"error-handling:GENERIC_ERROR"
				)
			);
		}
	}
}
